import * as api from './apiClient';

/**
 * The V2 inbox as the site's list expects it. Rows map onto the shape of the V1 items
 * (`_id`, `title`, `message`, `read`, `start_date`, `type`, `promo`/`content`/`screen`/`url`) so
 * `screens/Notifications` renders both without knowing which backend served them.
 */
export const toItem = row => {
  const action = row.action || { type: 'none' };
  const item = {
    _id: row.notification_id,
    v2: true,
    title: row.content?.title || '',
    message: row.content?.body || '',
    read: !!row.read,
    start_date: row.available_at || row.created_at,
    expiration_date: row.expires_at || null,
    type: action.type || 'none',
    category: row.category,
    campaign_id: row.campaign_id || null,
    data: row.content?.image_url ? { image: row.content.image_url } : undefined,
  };

  if (action.type === 'promo') {
    item.promo = { _id: action.target };
  }
  if (action.type === 'content') {
    item.content = { _id: action.target };
  }
  if (action.type === 'screen') {
    item.screen = action.target;
    item.screen_params = action.params || undefined;
  }
  if (action.type === 'url') {
    item.url = action.target;
  }

  return item;
};

/** First page(s) of the inbox, up to `max` rows, newest first. */
export const list = async ({
  max = 100,
  unread_only: unreadOnly = false,
} = {}) => {
  const items = [];
  let cursor = null;

  do {
    const page = await api.getInbox({
      limit: Math.min(50, max - items.length),
      cursor: cursor || undefined,
      unread_only: unreadOnly,
    });
    items.push(...(page?.notifications || []).map(toItem));
    cursor = page?.next_cursor || null;
  } while (cursor && items.length < max);

  return items;
};

export const unreadCount = async () => {
  const data = await api.getUnreadCount();
  return data?.unread || 0;
};

export const markRead = async ids => {
  await Promise.all((ids || []).map(id => api.markRead(id)));
};

export const markAllRead = async () => api.markAllRead();

export const archive = async id => api.archive(id);
